export default __webpack_public_path__ + "static/media/robot.f80e45e4.png";